import { createWebHistory, createRouter } from 'vue-router'
/* Layout */
import Layout from '@/layout'
import bodyScrollLayout from '@/layout/bodyScrollLayout'
import innerScrollLayout from '@/layout/innerScrollLayout.vue'

/**
 * Note: 路由配置项
 *
 * hidden: true                     // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true                 // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                  // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                  // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                  // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect             // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'               // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * query: '{"id": 1, "name": "ry"}' // 访问路由的默认传递参数
 * roles: ['admin', 'common']       // 访问路由的角色权限
 * permissions: ['a:a:a', 'b:b:b']  // 访问路由的菜单权限
 * meta : {
    noCache: true                   // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'                  // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'                // 设置该路由的图标，对应路径src/assets/icons/svg
    breadcrumb: false               // 如果设置为false，则不会在breadcrumb面包屑中显示
    activeMenu: '/system/user'      // 当路由设置了该属性，则会高亮相对应的侧边栏。
  }
 */

// 公共路由
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index.vue')
      }
    ]
  },
  {
    path: "/:pathMatch(.*)*",
    component: () => import('@/views/error/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error/401'),
    hidden: true
  },
  {
    path: '/login',
    component: () => import('@/views/login'),
    hidden: true
  },
  {
    path: '/',
    redirect: '/myResume/view', // 默认简历查看页
  },
  {
    path: '/post',
    component: innerScrollLayout,
    redirect: '/post/match',
    children: [
      {
        path: 'match',
        component: () => import('@/views/post/index'),
        name: 'PostMatch',
        meta: { documentTitle: '财略人才端', icon: 'dashboard', affix: true }
      }
    ]
  },

  {
    path: '/msgCenter',
    component: innerScrollLayout,
    children: [
      {
        path: '/msgCenter',
        component: () => import('@/views/msg/index'),
        name: 'MsgCenter',
        meta: { documentTitle: '财略人才端', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/myResume',
    component: innerScrollLayout,
    children: [
      {
        path: 'edit',
        component: () => import('@/views/myResume/edit'),
        name: 'MyResumeEdit',
        meta: { documentTitle: '财略人才端', icon: 'dashboard', affix: true }
      },
      {
        path: 'view',
        component: () => import('@/views/myResume/view'),
        name: 'MyResumeView',
        meta: { documentTitle: '财略人才端', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/testPage',
    component: () => import('@/views/test/index'),
    name: 'TestPage',
  },
]

// 动态路由，基于用户权限动态去加载
export const dynamicRoutes = [
]

const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
});

export default router;
